//import nom_image from "./mon_image"
import epaLogo from './logo-epa.svg';
import epaBackground from './figure-white.svg';

export const images = {
  epaLogo,
  epaBackground,
};
